export default "__VITE_ASSET__B2JuTl1F__"